export const indexItems = [
  { id: 1, title: '动作大片', desc: '热血激燃，肾上腺素飙升的视觉盛宴', count: 286, icon: 'ri-fire-line', color: 'accent' },
  { id: 2, title: '喜剧合家欢', desc: '笑料不断，全家共享的欢乐时光', count: 194, icon: 'ri-emotion-laugh-line', color: 'primary' },
  { id: 3, title: '爱情经典', desc: '心动瞬间，铭刻于心的浪漫故事', count: 157, icon: 'ri-heart-line', color: 'accent' },
  { id: 4, title: '科幻巨制', desc: '脑洞大开，探索未知的想象边界', count: 132, icon: 'ri-rocket-line', color: 'secondary' },
  { id: 5, title: '悬疑推理', desc: '烧脑反转，层层递进的真相追踪', count: 118, icon: 'ri-search-eye-line', color: 'primary' },
  { id: 6, title: '恐怖惊悚', desc: '毛骨悚然，深夜不敢独看的极限体验', count: 95, icon: 'ri-ghost-line', color: 'accent' },
  { id: 7, title: '动画世界', desc: '色彩斑斓，童心与想象力的大冒险', count: 203, icon: 'ri-palette-line', color: 'secondary' },
  { id: 8, title: '纪录片库', desc: '真实力量，触碰世界本来的模样', count: 76, icon: 'ri-earth-line', color: 'primary' },
  { id: 9, title: '战争史诗', desc: '宏大叙事，铭记历史的不朽篇章', count: 64, icon: 'ri-sword-line', color: 'accent' },
];

export const cardItems = [
  {
    id: 1, title: '《暗夜追缉》蝉联三周热度冠军', desc: '高智商犯罪片新标杆，豆瓣开分8.6，反转结局让百万网友直呼过瘾，播放量突破1.2亿次。',
    image: 'https://readdy.ai/api/search-image?query=Dark%20cinematic%20scene%20with%20neon%20lit%20city%20streets%20at%20night%2C%20mysterious%20figure%20in%20trench%20coat%2C%20rain%20slicked%20pavement%2C%20film%20noir%20aesthetic%2C%20warm%20amber%20and%20deep%20shadow%20contrast%2C%20atmospheric%20mood%2C%20cinematic%20photography%20style&width=800&height=500&seq=card-movie-01&orientation=landscape',
    tag: '热播推荐',
  },
  {
    id: 2, title: '暑期档五部必看国产佳片', desc: '从青春喜剧到现实题材，今年暑期档国产电影质量全面爆发，这五部高口碑作品收藏起来慢慢看。',
    image: 'https://readdy.ai/api/search-image?query=Warm%20summer%20cinema%20atmosphere%20with%20golden%20sunset%20light%2C%20outdoor%20movie%20screen%2C%20young%20people%20gathered%20watching%2C%20nostalgic%20film%20projector%20texture%2C%20soft%20warm%20tones%2C%20dreamy%20bokeh%20effect&width=800&height=500&seq=card-movie-02&orientation=landscape',
    tag: '编辑精选',
  },
  {
    id: 3, title: '经典港片4K修复版全集上线', desc: '天美影视独家引进百部经典港片4K修复版，《英雄本色》《重庆森林》《无间道》等悉数回归。',
    image: 'https://readdy.ai/api/search-image?query=Classic%20Hong%20Kong%20cinema%20aesthetic%2C%20vintage%20film%20grain%20texture%2C%20nostalgic%20street%20scene%20with%20neon%20signs%2C%20warm%20retro%20color%20palette%2C%20cinematic%20Asian%20cityscape%2C%20film%20photography%20mood&width=800&height=500&seq=card-movie-03&orientation=landscape',
    tag: '经典回归',
  },
  {
    id: 4, title: '韩国电影近年十佳作品盘点', desc: '从《寄生虫》横扫奥斯卡到《犯罪都市》系列票房神话，韩影为何持续产出惊喜？十部佳作一次看尽。',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20Korean%20film%20aesthetic%2C%20dramatic%20lighting%20on%20face%2C%20emotional%20portrait%20in%20warm%20and%20cool%20color%20contrast%2C%20artistic%20film%20poster%20style%2C%20soft%20focus%20background&width=800&height=500&seq=card-movie-04&orientation=landscape',
    tag: '深度盘点',
  },
  {
    id: 5, title: '周末观影指南：冷门高分佳片', desc: '避开热门大片的喧嚣，这十部容易被忽略的小众佳作，每一部都值得你花两个小时沉浸其中。',
    image: 'https://readdy.ai/api/search-image?query=Cozy%20indoor%20movie%20night%20scene%2C%20soft%20warm%20lamp%20light%2C%20comfortable%20sofa%20with%20blanket%2C%20large%20screen%20showing%20artistic%20film%2C%20intimate%20atmosphere%2C%20cinematic%20color%20grading&width=800&height=500&seq=card-movie-05&orientation=landscape',
    tag: '每周精选',
  },
];

export const appEntry = {
  title: '天美影视APP — 随时随地高清观影',
  desc: '支持离线缓存、倍速播放、弹幕互动，移动端极致观影体验。覆盖iOS / Android / iPad 全平台。',
  features: ['极速加载不缓冲', '1080P高清画质', '智能推荐片单', '夜间护眼模式'],
};

export const rankingItems = [
  { rank: 1, title: '暗夜追缉', type: '动作 / 犯罪', score: '9.2', heat: '1.2亿播放', change: 'up' },
  { rank: 2, title: '夏日奇迹', type: '青春 / 喜剧', score: '8.8', heat: '9860万播放', change: 'up' },
  { rank: 3, title: '深海迷踪', type: '科幻 / 冒险', score: '8.6', heat: '8720万播放', change: 'same' },
  { rank: 4, title: '归途列车', type: '剧情 / 家庭', score: '8.5', heat: '7650万播放', change: 'up' },
  { rank: 5, title: '长安十二夜', type: '悬疑 / 古装', score: '8.4', heat: '6890万播放', change: 'down' },
  { rank: 6, title: '冠军之路', type: '体育 / 励志', score: '8.3', heat: '6120万播放', change: 'up' },
  { rank: 7, title: '异星觉醒', type: '科幻 / 惊悚', score: '8.2', heat: '5580万播放', change: 'new' },
];

export const featureItems = [
  { id: 1, icon: 'ri-flashlight-line', title: '极速加载不缓冲', desc: '自建CDN节点覆盖全国，智能码率自适应技术确保在任何网络环境下都能流畅播放，告别转圈等待的烦恼。' },
  { id: 2, icon: 'ri-4k-line', title: '真高清画质体验', desc: '全站支持1080P高清画质，部分热门影片提供4K超清选项，搭配HDR色彩优化，还原影院级视觉享受。' },
  { id: 3, icon: 'ri-shield-check-line', title: '免费无广告观影', desc: '天美影视坚持免费观影理念，无需会员即可畅享全站内容，清爽界面无弹窗干扰，纯粹的电影时光。' },
];

export const commentItems = [
  { id: 1, name: '电影爱好者小王', text: '用天美影视三年了，片源更新速度真的快，基本上影院下映一周左右就能在这里看到高清版，画质也没得挑，推荐给所有喜欢看电影的朋友！', date: '2026-07-28' },
  { id: 2, name: '周末影迷会', text: '最惊喜的是经典老片的4K修复版专区，《霸王别姬》的修复画质太震撼了，每一帧都像油画一样。而且完全没有广告，观影体验比某些付费平台还好。', date: '2026-07-25' },
  { id: 3, name: '追剧小达人', text: 'APP端做的也很好，支持离线缓存，通勤路上看片神器。更新频率高，每天都有新内容上线，分类也很细致，找片特别方便。给团队点个赞！', date: '2026-07-22' },
];

export const updateItems = [
  { id: 1, date: '07-31', title: '《暗夜追缉》累计播放突破1.2亿', type: '数据' },
  { id: 2, date: '07-30', title: '新增「杜比全景声」音效选项上线', type: '功能' },
  { id: 3, date: '07-29', title: '《长安十二夜》大结局提前解锁', type: '更新' },
  { id: 4, date: '07-28', title: '暑期档专题「夏日影院」正式上线', type: '专题' },
  { id: 5, date: '07-27', title: '经典港片专区新入库32部修复版', type: '更新' },
  { id: 6, date: '07-26', title: 'APP 3.2版本发布，新增AI推荐功能', type: '功能' },
  { id: 7, date: '07-25', title: '与三大国际电影节达成内容合作', type: '合作' },
  { id: 8, date: '07-24', title: '日活用户突破500万，感谢陪伴', type: '里程碑' },
  { id: 9, date: '07-23', title: '「科幻电影周」专题片单限时放送', type: '专题' },
];

export const aboutInfo = {
  title: '关于天美影视',
  desc: '天美影视成立于2018年，是国内领先的高清免费在线观影平台。我们致力于为广大电影爱好者提供最丰富、最优质、最流畅的观影体验。平台目前收录超过3万部电影作品，涵盖动作、喜剧、科幻、悬疑、爱情、动画等全品类内容，每日更新最新上映影片。天美影视以"让每个人都能轻松看好电影"为使命，坚持免费无广告的运营理念，用技术驱动观影体验的持续优化。',
  stats: [
    { value: '30,000+', label: '影片资源' },
    { value: '500万+', label: '日活用户' },
    { value: '99.9%', label: '播放成功率' },
  ],
};

export const carouselItems = [
  {
    id: 1, title: '暑期档观影指南', desc: '这个夏天最值得期待的电影都在这里，从国产大片到好莱坞巨制，15部必看新片一次盘点，帮你合理安排暑期观影时间。', tag: '编辑精选',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20summer%20movie%20festival%20poster%20collage%2C%20warm%20golden%20tone%2C%20film%20strip%20elements%2C%20vintage%20cinema%20aesthetic%2C%20soft%20dramatic%20lighting%2C%20artistic%20composition&width=1000&height=600&seq=carousel-01&orientation=landscape',
  },
  {
    id: 2, title: '港片黄金时代', desc: '从邵氏经典到新浪潮，重温香港电影最辉煌的三十年。百部4K修复版港片限时展映，带你回到那个群星闪耀的年代。', tag: '经典回顾',
    image: 'https://readdy.ai/api/search-image?query=Retro%20Hong%20Kong%20street%20scene%20with%20neon%20signs%2C%20classic%20cinema%20poster%20wall%2C%20vintage%20film%20nostalgia%2C%20warm%20amber%20and%20red%20tones%2C%20cinematic%20urban%20aesthetic&width=1000&height=600&seq=carousel-02&orientation=landscape',
  },
  {
    id: 3, title: '科幻迷的终极片单', desc: '从《2001太空漫游》到《星际穿越》，从《银翼杀手》到《沙丘》，横跨半个世纪的科幻电影名作，一次完整的类型巡礼。', tag: '深度专题',
    image: 'https://readdy.ai/api/search-image?query=Futuristic%20sci-fi%20cinema%20concept%2C%20deep%20space%20nebula%20colors%2C%20starship%20silhouette%2C%20cinematic%20atmosphere%20with%20dramatic%20lighting%2C%20golden%20and%20teal%20color%20contrast&width=1000&height=600&seq=carousel-03&orientation=landscape',
  },
  {
    id: 4, title: '动画电影的无限可能', desc: '动画不只是给孩子看的。从宫崎骏的治愈世界到皮克斯的奇思妙想，从国产动画的崛起到欧洲独立动画的美学探索，发现动画的多元魅力。', tag: '主题策划',
    image: 'https://readdy.ai/api/search-image?query=Artistic%20animation%20film%20still%20aesthetic%2C%20hand-drawn%20style%20texture%2C%20warm%20colorful%20palette%2C%20dreamy%20fantasy%20landscape%2C%20soft%20magical%20atmosphere%2C%20studio%20ghibli%20inspired&width=1000&height=600&seq=carousel-04&orientation=landscape',
  },
];

export const contactInfo = {
  title: '联系我们',
  desc: '欢迎投稿、合作或提出宝贵意见。你的每一个建议都能帮助天美影视变得更好。',
  email: 'contact@tianmeiying.com',
  wechat: 'tianmeiyingkefu',
};

export const topicItems = [
  { id: 1, name: '暗夜追缉', count: '1.2亿', color: 'accent' },
  { id: 2, name: '暑期档', count: '9800万', color: 'primary' },
  { id: 3, name: '经典港片', count: '8650万', color: 'secondary' },
  { id: 4, name: '悬疑反转', count: '7420万', color: 'accent' },
  { id: 5, name: '科幻巨制', count: '6890万', color: 'primary' },
  { id: 6, name: '4K修复', count: '6210万', color: 'secondary' },
  { id: 7, name: '国产动画', count: '5580万', color: 'accent' },
  { id: 8, name: '韩影精选', count: '4920万', color: 'primary' },
  { id: 9, name: '纪录片', count: '4350万', color: 'secondary' },
  { id: 10, name: '爱情经典', count: '3980万', color: 'accent' },
  { id: 11, name: '高分冷门', count: '3520万', color: 'primary' },
];

export const mediaItems = [
  {
    id: 1, title: '《暗夜追缉》幕后特辑', desc: '导演深度专访，揭秘高智商犯罪片创作背后的故事与挑战', duration: '18:24',
    image: 'https://readdy.ai/api/search-image?query=Film%20director%20on%20set%20with%20warm%20lighting%2C%20behind%20the%20scenes%20cinematography%2C%20professional%20camera%20equipment%2C%20artistic%20documentary%20style%2C%20cinematic%20mood&width=600&height=340&seq=media-01&orientation=landscape',
  },
  {
    id: 2, title: '暑期档新片速览', desc: '五分钟看完暑期档最值得期待的十部新片预告合集', duration: '05:12',
    image: 'https://readdy.ai/api/search-image?query=Movie%20theater%20interior%20with%20warm%20red%20velvet%20seats%2C%20glowing%20screen%2C%20summer%20blockbuster%20atmosphere%2C%20cinematic%20lighting%2C%20immersive%20viewing%20experience&width=600&height=340&seq=media-02&orientation=landscape',
  },
  {
    id: 3, title: '经典港片回顾', desc: '从《英雄本色》到《无间道》，港片黄金时代的视觉记忆', duration: '22:08',
    image: 'https://readdy.ai/api/search-image?query=Vintage%20Hong%20Kong%20cinema%20marquee%20with%20classic%20film%20posters%2C%20nostalgic%20neon%20lighting%2C%20retro%20theater%20entrance%2C%20warm%20golden%20hour%20light&width=600&height=340&seq=media-03&orientation=landscape',
  },
  {
    id: 4, title: '动画电影大赏', desc: '从手绘到CG，动画电影百年发展历程中的美学革命', duration: '15:36',
    image: 'https://readdy.ai/api/search-image?query=Animation%20studio%20workspace%20with%20warm%20lighting%2C%20hand-drawn%20sketches%20on%20desk%2C%20colorful%20storyboard%20panels%2C%20creative%20artistic%20atmosphere%2C%20soft%20focus&width=600&height=340&seq=media-04&orientation=landscape',
  },
];

export const faqItems = [
  { id: 1, question: '天美影视是否需要注册会员才能观看？', answer: '不需要。天美影视坚持免费观影理念，所有影片无需注册登录即可直接观看。我们希望通过零门槛的方式，让更多人享受电影的乐趣。' },
  { id: 2, question: '影片画质如何？是否有高清选项？', answer: '天美影视全站影片支持1080P高清画质，部分热门内容提供4K超清选项。我们采用智能码率自适应技术，会根据你的网络情况自动匹配最佳画质。' },
  { id: 3, question: '为什么有些影片加载速度比较慢？', answer: '影片加载速度主要取决于你的网络环境。天美影视部署了全国CDN加速节点，通常情况下都能实现秒开无缓冲。如遇卡顿，建议切换到较低清晰度或检查本地网络。' },
  { id: 4, question: '支持哪些设备观看？有没有APP？', answer: '天美影视支持电脑、平板、手机等全设备访问，同时提供iOS和Android APP下载。APP支持离线缓存、倍速播放和弹幕互动等高级功能。' },
  { id: 5, question: '影片更新频率如何？新片多久上线？', answer: '我们每天更新影片资源，新上映的热门电影一般在影院下映后1-2周内上线高清版本。同时我们还提供经典老片、独立电影和纪录片等丰富的专题内容。' },
];

export const navItems = [
  { id: 'carousel', label: '精选专题' },
  { id: 'updates', label: '最新动态' },
  { id: 'index', label: '主题索引' },
  { id: 'ranking', label: '热播排行' },
  { id: 'media', label: '精彩视频' },
];